export const LOGIN = 'LOGIN';
export const SEARCH = 'SEARCH';
export const SHORTCUTS = 'SHORTCUTS';
export const NAVIGATION = 'NAVIGATION';
export const USER = 'USER';
export const COMPANY = 'COMPANY';
export const COMPANY_MEMBER = 'COMPANY_MEMBER';
export const INVESTOR = 'INVESTOR';

export const DIALOGS = {
  LOGIN,
  SEARCH,
  SHORTCUTS,
  NAVIGATION,
  USER,
  COMPANY,
  COMPANY_MEMBER,
  INVESTOR,
} as const;
